/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactList from 'react-list';

export default class VirtualizedList extends Component {
	static propTypes = {
		length: PropTypes.number.isRequired,
		itemRenderer: PropTypes.func.isRequired,
		itemsRenderer: PropTypes.func,
		initialIndex: PropTypes.number,
		listType: PropTypes.oneOf(['uniform', 'simple', 'variable']),
		itemSizeEstimator: PropTypes.func,
		itemSizeGetter: PropTypes.func,
	};

	static defaultProps = {
		listType: 'uniform',
		selectionMode: 'none',
	};

	scrollAround(index) {
		const visibleRange = this._list.getVisibleRange();
		if (visibleRange[0] > index) {
			this._list.scrollAround(
				Math.max(0, Math.ceil(index - (visibleRange[1] - visibleRange[0]) / 2))
			);
		} else if (visibleRange[1] < index) {
			this._list.scrollAround(
				Math.min(
					this.props.length - 1,
					Math.floor(index + (visibleRange[1] - visibleRange[0]) / 2)
				)
			);
		} else if (index === visibleRange[0] || index === visibleRange[1]) {
			this._list.scrollAround(index);
		}
	}

	scrollTo(index) {
		this._list.scrollTo(index);
	}

	getVisibleRange() {
		return this._list.getVisibleRange();
	}

	_ref = list => {
		this._list = list;
	};

	render() {
		const {
			listType,
			length,
			initialIndex,
			itemSizeGetter,
			itemSizeEstimator,
			itemRenderer,
			itemsRenderer,
		} = this.props;

		return (
			<ReactList
				type={listType}
				itemRenderer={itemRenderer}
				itemsRenderer={itemsRenderer}
				length={length}
				initialIndex={initialIndex}
				ref={this._ref}
				itemSizeEstimator={itemSizeEstimator}
				itemSizeGetter={itemSizeGetter}
			/>
		);
	}
}
